import React, { useState, useEffect, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import './Css/Materials.css';
import './Css/Materials-responsive.css';
import { Ripple } from "primereact/ripple";
import { Toast } from 'primereact/toast';
import NoDataCreated from "../../../Components/NoDataCreated";
import PageLoader from "../../../Components/PageLoader";
import ErrorPage from "../../../Components/ErrorPage";
import { goToTop } from "../../../Components/goToTop";
import { useAppDispatch, useAppSelector } from "../../../Controllers/hooks";
import { getAllMaterialProjectList, getAllMaterialTemplateList } from "../../../Controllers/Thunks/HeyTraderThunks";
import { MaterialPojectType } from "../../../Controllers/Types/HeyTraderTypes/Materials/MaterialPojectType";
import { MaterialTemplateType } from "../../../Controllers/Types/HeyTraderTypes/Materials/MaterialTemplateType";

const MaterialOption: React.FC = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const toast = useRef<Toast>(null);

    const [materialState, setMaterialState] = useState<'Custom' | 'Template'>('Template')
    const [projectDetails, setProjectDetails] = useState<MaterialPojectType | null>(null);
    const [materialTemplatesData, setMaterialTemplatesData] = useState<MaterialTemplateType[]>([]);

    // for the resons
    const dispatch = useAppDispatch();

    // for fetching data fro api tigger with state object actions
    useEffect(() => {
        dispatch(getAllMaterialProjectList());
        dispatch(getAllMaterialTemplateList());
    }, [dispatch]);

    // this is get data from state list and set projectlist
    const ProjectsList = useAppSelector((state) => state?.materialProject?.materialProjectList);
    const loadingPage = useAppSelector((state) => state?.materialProject?.loader);
    const error = useAppSelector((state) => state?.materialProject?.errorDisplay);
    const TemplateList = useAppSelector((state) => state?.materialTemplates?.templateList);
    const loadingTemplates = useAppSelector((state) => state?.materialTemplates?.loader);

    //   chnage reail time responce with updated project info/
    useEffect(() => {
        if (location.state && location.state.projectData) {
            const globleproject = location.state.projectData as MaterialPojectType;
            const listpro = ProjectsList.filter(
                (e) => e.project_id === globleproject.project_id
            );
            if (listpro.length > 0) {
                setProjectDetails(listpro[0] as MaterialPojectType);
            } else {
                setProjectDetails(globleproject);
            }
        }
    }, [location.state, ProjectsList]);

    useEffect(() => {
        const fetchData = async () => {
            const activeTemplatesData = TemplateList?.filter((template) => template.status === 1);
            setMaterialTemplatesData(activeTemplatesData);
        }
        fetchData();
    }, [TemplateList]);

    const handleSwitchMaterialState = (state: 'Custom' | 'Template') => {
        setMaterialState(state);
    }

    const handleAddCustomMaterial = () => {
        navigate(`/materials`, { state: { projectData: projectDetails } });
        goToTop();
    }

    const handleSelectMaterialTemplate = (template: MaterialTemplateType) => {
        const templateData = template;
        navigate(`/materials/template`, { state: { templateData: templateData, projectData: projectDetails } });
        goToTop();
    }

    /* **************************** Common functions ***************************** */
    const goBack = () => {
        navigate(-1);
        goToTop();
    };
    /* *************************************************************************** */

    return (
        <React.Fragment>
            <Toast ref={toast} />

            <div className="main_content layout_padding show_side_bar">
                {(loadingPage || loadingTemplates) ? (
                    <PageLoader />
                ) : error ? (
                    <ErrorPage errorMessage={error} />
                ) : (
                    <div className="page_content mt-0">
                        <div className="page_breadcrumb_area">
                            <ul className="page_breadcrumb">
                                <li className="page_breadcrumb_item has_child has_link" onClick={() => navigate(-1)}>
                                    Materials
                                </li>

                                <li className="page_breadcrumb_item active">
                                    {projectDetails?.job_number + ': ' + projectDetails?.address}
                                </li>
                            </ul>

                            <button className="back_btn p-ripple" onClick={goBack}>
                                <i className="bi bi-arrow-left me-2"></i>
                                Back
                                <Ripple />
                            </button>
                        </div>

                        <div className="page_header_area mt-sm-3 mt-3">
                            <div className="contact_tabs">
                                <div className="contact_tab_item">
                                    <button type="button"
                                        className={`contact_tab_btn ${materialState === 'Template' ? 'active' : ''} p-ripple fixed_width`}
                                        onClick={() => (handleSwitchMaterialState('Template'))}>
                                        Template
                                        <Ripple pt={{ root: { style: { background: 'rgba(164, 96, 253, 0.2)' } } }} />
                                    </button>
                                </div>
                                <div className="contact_tab_item">
                                    <button type="button"
                                        className={`contact_tab_btn ${materialState === 'Custom' ? 'active' : ''} p-ripple fixed_width`}
                                        onClick={handleAddCustomMaterial}>
                                        Custom
                                        <Ripple pt={{ root: { style: { background: 'rgba(164, 96, 253, 0.2)' } } }} />
                                    </button>
                                </div>
                            </div>
                        </div>

                        <div className="page_main_content_section p-sm-3 p-xxl-4 p-xl-3 p-lg-3 p-2">
                            {materialState === 'Template' && (
                                <React.Fragment>
                                    {materialTemplatesData && materialTemplatesData?.length > 0 ? (
                                        <div className="row sow_template_row">
                                            {materialTemplatesData?.map((template) => (
                                                <div key={template.id} className="col-12 col-sm-6 col-lg-6 col-xl-4">
                                                    <article className="sow_template material p-ripple"
                                                        onClick={() => handleSelectMaterialTemplate(template)}>
                                                        <h6>{template?.template_name}</h6>
                                                        <Ripple />
                                                    </article>
                                                </div>
                                            ))}
                                        </div>
                                    ) : (
                                        <NoDataCreated
                                            message={`No template(s) found for materials. Please use custom option instead.`}
                                        />
                                    )}
                                </React.Fragment>
                            )}
                        </div>
                    </div>
                )}
            </div>
        </React.Fragment>
    )
}

export default MaterialOption;